module.exports = __webpack_public_path__ + "img/Sabiat1.869959ef.jpg";